import React, { useContext, useEffect, useState } from 'react';

import { HttpMethods, FetchContext, ApiRoutes } from '../../../../contexts';
import { useAggregatedState } from '../../../../../helpers';

export const AdministrativeContext = React.createContext(null);

const { Provider } = AdministrativeContext;
export const AdministrativeProvider = (props) => {
    const { fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
    });

    return (
        <Provider value={{
            state
        }}>
            {props.children}
        </Provider>
    );
}